/**
 *
 * @author Aleynikov Boris <alynikov.boris@gmail.com>.
 */

'use strict';

var app = require('mag-app'),
    isStandByPaused = false,
    hdmiEventReaction = {
        timer: null,
        paused: false
    };

/*eslint new-cap:0*/

window.gSTB = window.parent.gSTB;

// init player
window.top.gSTB.SetTopWin(0);

window.top.gSTB.SetSubtitlesFont('/usr/lib/fonts/Ubuntu.ttf');

module.exports = function ( systemPlayer ) {
    /**
     * HDMI event reaction
     */
    window.parent.stbEvent.addListener('media', function (event) {
        // go to sleep
        if ( event.code === 33 && core.environment.hdmi_event_delay ) {
            console.log('HDMI:: go to sleep');
            // window.standByModes.push('HDMI:: go to sleep');
            clearTimeout(hdmiEventReaction.timer);
            hdmiEventReaction.timer = setTimeout(function () {
                if ( app.pipIntent ) {
                    app.pipIntent.emit('stop');
                }
                if ( systemPlayer.primary.state === 2 ) {
                    systemPlayer.primary.pause();
                    hdmiEventReaction.paused = true;
                } else {
                    hdmiEventReaction.paused = false;
                }

            }, core.environment.hdmi_event_delay * 1000);

        } else if ( event.code === 32 ) {
            console.log('HDMI:: wake up');
            // window.standByModes.push('HDMI:: wake up');
            // wake up
            clearTimeout(hdmiEventReaction.timer);
            if ( hdmiEventReaction.paused ) {
                hdmiEventReaction.paused = false;
                systemPlayer.primary.resume();
            }
        }
    });


    // /**
    //  * Standby reaction
    //  */
    // core.addListener('standby', function ( event ) {
    //     event = event || {};
    //
    //     // stand by on
    //     // when timeshift will be work and activated we should ask some question to stop it
    //     if ( event.status ) {
    //         if ( systemPlayer.primary.state === 2 ) {
    //             systemPlayer.primary.pause();
    //             isStandByPaused = true;
    //         }
    //     } else {
    //         // wake up
    //         if ( app.pipIntent ) {
    //             app.pipIntent.emit('stop');
    //         }
    //         if ( isStandByPaused ) {
    //             systemPlayer.primary.play({uri: app.lastPlayUri});
    //             isStandByPaused = false;
    //         }
    //     }
    //
    // });


    /**
     * Standby reaction
     */
    core.plugins.standby.addListener('standbyOn', function () {

        console.log('STANDBY ON:');
        //
        if ( systemPlayer.primary.state === 2 ) {
            systemPlayer.primary.pause();
            isStandByPaused = true;
        }
    });

    core.plugins.standby.addListener('standbyOff', function () {
        console.log('STANDBY OFFF:');
        //
        if ( app.pipIntent ) {
            app.pipIntent.emit('stop');
        }
        if ( isStandByPaused ) {
            console.log('continue playing after standby');
            systemPlayer.primary.play({uri: app.lastPlayUri});
            isStandByPaused = false;
        }
    });

};
